// Which bundled icon (assets/icons, resolved by data/icons.ts) sits on each sized use case's card.
// Presentation only, so it lives with the v3 components rather than in the catalog. Unsized use
// cases have no icon; the card renders a spacer so labels stay aligned.

import { iconUrl } from '../../data/icons';

const ICON_PATH: Record<string, string> = {
  'uc-crm-enrichment': 'assets/icons/CRM.png',
  'uc-account-lead-scoring': 'assets/icons/Score-Accounts.png',
  'uc-tam-sourcing': 'assets/icons/Target.png',
  'uc-inbound-speed-to-lead': 'assets/icons/Inbound.png',
  'uc-automated-outbound': 'assets/icons/Outbound.png',
  'uc-performance-marketing': 'assets/icons/Ads.png',
  'uc-rep-prospecting': 'assets/icons/Find-People.png',
  'uc-signal-based-outbound': 'assets/icons/Signals-satellite.png',
  'uc-plg-expansion': 'assets/icons/Customer-Expansion.png',
  'uc-abm': 'assets/icons/Build-campaign.png',
  'uc-tool-consolidation': 'assets/icons/Toolbox.png',
  'uc-gtm-automation': 'assets/icons/Automation.png',
};

export function useCaseIconUrl(useCaseId: string): string | null {
  const path = ICON_PATH[useCaseId];
  return path ? iconUrl(path) : null;
}
